module.exports = __webpack_public_path__ + "static/media/gith.c3858c8f.jpg";